export default __webpack_public_path__ + "static/media/outline-icons.c5240512.woff2";